// import "babel-polyfill";
import layerInfo from "./classchange/layer-info";
import selectBox from "./classchange/selectbox";
import selectInfo from "./classchange/select-info";

let layer = {}, select = {};
$.each(layerInfo, function(index, value){
    layer[value.name] = promokit.layer({
        el:value.el,
        buttons:value.btn,
        render:value.render
    });
});
$.each(selectInfo, function(index, value){
    select[value.name] = new selectBox({
        el:value.el,
        scHeight:179
    });
});

let page = promokit.page({
    caution:'#section-caution',
    cnb:true, //true, false
    topButton:true, //true, false
    footer:{
        theme:'white' //'black', 'white'
    },
    headerButton:{
        el:'.header-button',
        home:true,
        event:true,
        sns:true,
        theme:'black' //'black', 'white'
    }
});

$(document).on('click', '.cases__btn--login', function(){
    promokit.login();
});

$(".p-header__floating").on("click", function(){
    let posY = $("#section-3").offset().top-70;
    $("html, body").stop().animate({scrollTop:posY}, 400);
});


// WEBPACK FOOTER //
// ./src/js/classchange.js